import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import LoadingScreen from 'components/Shared/LoadingScreen';
import MenuContainer from 'components/Shared/MenuContainer';
import PERMISSIONS from 'constants/permissions';
import Button from 'uikit/Button';

import Student from './Student';
import Teacher from './Teacher';
import styles from './Course.module.scss';

const cx = classNames.bind(styles);

const Course = ({
  course,
  // isInNative,
  isInTeams,
  isLoading,
  t,
}) => (
  <MenuContainer>
    <div className={cx('header')}>
      {!isInTeams && (
        <Button
          aria-label={t('Course/back')}
          as={Link}
          className={cx('back')}
          icon="arrow-left"
          intent="white"
          to={{
            pathname: '/',
            state: {
              currentDisplayedCourseId: course?.id,
            },
          }}
        />
      )}
    </div>
    {isLoading ? (
      <LoadingScreen />
    ) : course.level >= PERMISSIONS.COLLABORATOR ? ( // ) : course.level >= PERMISSIONS.COLLABORATOR && !isInNative ? (
      <Teacher course={course} />
    ) : (
      <Student course={course} />
    )}
  </MenuContainer>
);

Course.propTypes = {
  course: PropTypes.object,
  // isInNative: PropTypes.bool.isRequired,
  isInTeams: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

Course.defaultProps = {
  course: undefined,
};

export default Course;
